import React from 'react';
import { LegislationIcon } from '../../../../../components/entities-card/icons/LegislationIcon';
import styles from './no_link_legislation_title.module.scss';

export function NoLinkLegislationTitle({
  children,
}: React.HTMLProps<HTMLDivElement>) {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>{LegislationIcon}</div>
      {children}
    </div>
  );
}
